<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="pageloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Perduoti sandorį kitam notarui</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-4">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <el-text-field
                  label="Pranešimo rūšis"
                  :readonly="true"
                  v-model="perdavimasTipas"
                />
              </v-col>
            </v-row>
            <template v-if="!perdavimasProgress && showConfirm">
              <v-row>
                <v-col cols="12">
                  <span v-html="confirmText"></span>
                </v-col>
              </v-row>
            </template>
            <template v-if="perdavimasProgress">
              <v-alert class="mt-5" type="info" outlined color="green">
                Sandoris perduodamas kitam notarui
              </v-alert>
            </template>

            <template v-if="!perdavimasProgress && !showConfirm">
              <v-row>
                <v-col cols="12">
                  <el-autocomplete
                    :items="notaraiList"
                    itemvalue="snau_id"
                    itemtext="snau_pavadinimas"
                    return-object
                    label="Perduoti notarui"
                    v-model="notaras"
                  />
                </v-col>
                <template v-if="isNotaras">
                  <v-col cols="12" md="6">
                    <el-text-field
                      label="Vardas"
                      :readonly="true"
                      v-model="notaras.snau_vardas"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <el-text-field
                      label="Pavardė"
                      :readonly="true"
                      v-model="notaras.snau_pavarde"
                    />
                  </v-col>
                  <v-col cols="12" md="12">
                    <el-text-field
                      label="Notaro biuro pavadinimas"
                      :readonly="true"
                      v-model="notaras.snau_kontora"
                    />
                  </v-col>
                  <v-col cols="12" md="12">
                    <el-text-field
                      label="Sutarties Nr."
                      :readonly="true"
                      v-model="notaras.snau_sutartis_nr"
                    />
                  </v-col>
                </template>
              </v-row>
            </template>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button :loading="loading" @click.native="cancel()">
          Atšaukti
        </el-button>
        <el-button
          :loading="loading"
          primary
          @click.native.stop="perdavimasConfirm()"
          v-if="isNotaras && !isConfirm"
        >
          Perduoti
        </el-button>
        <el-button
          :loading="loading"
          primary
          @click.native.stop="saveData()"
          v-if="isConfirm"
        >
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalPerdavimas',
  props: {
    value: Boolean,
    item: Object,
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      perdavimasProgress: false,
      showConfirm: false,
      notarai: [],
      notaras: {
        snau_id: null,
        snau_pavadinimas: null,
      },
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    perdavimasTipas() {
      return this.item ? this.item.hipotekaTipas : ''
    },
    notaraiList() {
      return this.notarai.map(item => {
        return item
      })
    },
    isNotaras() {
      return this.notaras.snau_id
    },
    isConfirm() {
      return this.showConfirm
    },
    confirmText() {
      return `Ar tikrai norite perduoti rengiamą sandorį kitam notarui <b>${this.notaras.snau_pavadinimas}, ${this.notaras.snau_kontora}</b>?<br />
      Visi neįvykdyti tikslinimai ir vertinimai bus atšaukti.`
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getData()
      }
    },
  },
  created() {},
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.perdavimasProgress = false
      this.showConfirm = false
      this.notarai = []
      this.notaras = {
        snau_id: null,
        snau_pavadinimas: null,
      }

      this.$axios
        .get(`perdavimas/notarai`)
        .then(res => {
          this.notarai = res.data.notarai
          if (this.notarai.length === 1) {
            this.notaras = this.notarai[0]
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData() {
      this.loading = true
      this.perdavimasProgress = true

      this.$emit('confirmPerdavimas', {
        obj_id: this.item.obj_id,
        snau_id: this.notaras.snau_id,
      })
    },
    perdavimasConfirm() {
      this.showConfirm = true
    },
    cancelData() {
      this.$emit('cancelPerdavimas')
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.cancelData()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
